function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_white)"
}, React.createElement("path", {
  d: "M3.10504 6C3.10504 4.34315 4.44819 3 6.10504 3H36.167C37.8238 3 39.167 4.34315 39.167 6V28.6023C39.167 29.6409 38.6298 30.6056 37.7469 31.1525L22.716 40.4646C21.748 41.0642 20.524 41.0642 19.5561 40.4646L4.5251 31.1525C3.64222 30.6056 3.10504 29.6409 3.10504 28.6023V6Z",
  fill: "url(#paint0_linear_29_28)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d_29_28)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9238 10.2139L12.9239 22.6196L17.8739 22.5902V18.3173H21.7312L25.0343 22.5864H29.7859L26.3579 18.1561C28.9875 17.6036 29.9818 15.7862 29.9818 14.2327C29.9818 12.3188 29.2168 10.2139 24.2561 10.2139L12.9238 10.2139ZM17.8585 12.9876H23.9541C23.9541 12.9876 25.1568 12.9876 25.1568 14.171C25.1568 15.3544 23.9541 15.4473 23.9541 15.4473H17.8585V12.9876Z",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter1_d_29_28)"
}, React.createElement("path", {
  d: "M13.5784 30.0742L12.6132 26.8015H13.604L14.0514 28.815H14.077L14.6075 26.8015H15.3874L15.9179 28.8214H15.9435L16.3909 26.8015H17.3817L16.4165 30.0742H15.5664L15.0102 28.2461H14.9847L14.4286 30.0742H13.5784ZM18.1193 30.0742V26.8015H19.0078V28.0799H20.184V26.8015H21.0725V30.0742H20.184V28.7958H19.0078V30.0742H18.1193ZM22.8328 26.8015V30.0742H21.9443V26.8015H22.8328ZM23.6144 27.5174V26.8015H26.4589V27.5174H25.4745V30.0742H24.5988V27.5174H23.6144ZM27.2433 30.0742V26.8015H29.6019V27.5174H28.1318V28.0799H29.4805V28.7958H28.1318V29.3583H29.5955V30.0742H27.2433Z",
  fill: "white"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_white",
  x: 0,
  y: 0,
  width: 42,
  height: 43,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
})), React.createElement("filter", {
  id: "filter0_d_29_28",
  x: 11.4654,
  y: 10.2139,
  width: 19.9749,
  height: 15.3227,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 1.45847
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.729234
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_28"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_28",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_d_29_28",
  x: 8.9768,
  y: 23.1651,
  width: 24.2616,
  height: 10.5456,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 1.81822
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.478431 0 0 0 0 0.156863 0 0 0 0 0.823529 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_28"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_28",
  result: "shape"
})), React.createElement("linearGradient", {
  id: "paint0_linear_29_28",
  x1: 21.136,
  y1: 3,
  x2: 21.136,
  y2: 41.4342,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7D1FF5",
  stopOpacity: 0.95
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#DA48C5"
})));

var SvgWhiteNoBorder = function SvgWhiteNoBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWhiteNoBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white_no_border.3dafb8ac.svg";
export { ForwardRef as ReactComponent };